<div
  *ngIf="consentService.showBanner$ | async"
  class="tr-consent"
  role="dialog"
  aria-label="Cookie consent"
  aria-live="polite"
>
  <div class="tr-consent__card">
    <button
      type="button"
      class="tr-consent__close"
      aria-label="Close — you'll be asked again next time"
      (click)="dismiss()"
    >
      &times;
    </button>

    <!-- Default banner view -->
    <ng-container *ngIf="!showPreferences">
      <div class="tr-consent__body">
        <p class="tr-consent__title">We value your privacy</p>
        <p class="tr-consent__text">
          We use cookies and similar technologies for analytics and advertising to understand
          how the app is used and to measure our campaigns. See our
          <a [href]="cookieNoticeUrl" target="_blank" rel="noopener">Cookie Notice</a> and
          <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">Privacy Policy</a>.
        </p>
      </div>
      <div class="tr-consent__actions">
        <button type="button" class="btn btn-primary" (click)="acceptAll()">Accept all</button>
        <button type="button" class="btn btn-outline-secondary" (click)="rejectAll()">Reject all</button>
        <button type="button" class="btn btn-link tr-consent__prefs-link" (click)="openPreferences()">
          Preferences
        </button>
      </div>
    </ng-container>

    <!-- Preferences view -->
    <ng-container *ngIf="showPreferences">
      <div class="tr-consent__body">
        <p class="tr-consent__title">Cookie preferences</p>
        <p class="tr-consent__text">
          Choose which categories to allow. Strictly necessary cookies are always on.
        </p>

        <div *ngIf="gpcEnabled" class="tr-consent__gpc-note">
          We detected a Global Privacy Control signal in your browser and have opted you out of
          the sale or sharing of your personal information (advertising). You can still enable
          analytics below.
        </div>

        <div class="tr-consent__category">
          <div>
            <p class="tr-consent__category-name">Strictly necessary</p>
            <p class="tr-consent__category-desc">
              Required for the app to work — security, forms, and remembering your consent
              choice. Always active.
            </p>
          </div>
          <span class="tr-consent__always-on">Always on</span>
        </div>

        <label class="tr-consent__category tr-consent__category--toggle">
          <div>
            <p class="tr-consent__category-name">Analytics</p>
            <p class="tr-consent__category-desc">
              Google Analytics (via Google Tag Manager) to understand how the app is used.
            </p>
          </div>
          <input type="checkbox" class="form-check-input" [(ngModel)]="analyticsChecked" />
        </label>

        <label class="tr-consent__category tr-consent__category--toggle">
          <div>
            <p class="tr-consent__category-name">Advertising</p>
            <p class="tr-consent__category-desc">
              Google Ads conversion measurement and campaign attribution for keyword-based
              search ads. Treated as a &ldquo;sale/share&rdquo; under some state laws.
            </p>
          </div>
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="adsChecked"
            [disabled]="gpcEnabled"
          />
        </label>
      </div>
      <div class="tr-consent__actions">
        <button type="button" class="btn btn-primary" (click)="savePreferences()">Save preferences</button>
        <button type="button" class="btn btn-outline-secondary" (click)="rejectAll()">Reject all</button>
      </div>
    </ng-container>
  </div>
</div>
